export default __webpack_public_path__ + "static/media/dreamfest (16).77f0c209.jpg";